import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { ts } from "src/utils/translate";
import { CustomCell } from "src/pages/OfferPage/TableSvgOrganizer/CustomCell";
import { TableCell } from "src/pages/OfferPage/TableSvgOrganizer/TableCell";
import { RowTools } from "src/pages/OfferPage/TableSvgOrganizer/RowTools/RowTools";
import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage";
import { addEditableMinusRow } from "src/utils/CustomRowUtils";
import {
  useAddCableCustomItemMutation,
  useAddConventionalDevicesCustomItemMutation,
  useAddElectricalCustomItemMutation,
  useAddNhcCustomItemMutation,
  useAddProjectCustomItemMutation,
  useAddRackCabinetCustomItemMutation,
  useAddRoomCustomItemMutation
} from "src/api/v1/quote-ApiSlice";
import { useAddCustomSectionItemMutation } from "src/api/v1/section-ApiSlice";

export const CustomMinusRow = (
    {
      neededCols,
      cancelCustomRow,
      entityType,
      entityId,
      currency,
      customItem,
      setCustomItem,
      customMinusRowButtonPressed,
      setCustomMinusRowButtonPressed,
      setCurrentRowInEditing,
      measurementSystem,
    }: {
      neededCols: any;
      cancelCustomRow: () => void;
      entityType: any;
      entityId: any;
      currency: string;
      customItem: any;
      setCustomItem: any;
      customMinusRowButtonPressed: boolean;
      setCustomMinusRowButtonPressed: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
}
) => {

  const [ addRoomCustomItem ] = useAddRoomCustomItemMutation();
  const [ addProjectCustomItem ] = useAddProjectCustomItemMutation();
  const [ addElectricalCustomItem ] = useAddElectricalCustomItemMutation();
  const [ addNhcCustomItem ] = useAddNhcCustomItemMutation();
  const [ addCustomSectionItem ] = useAddCustomSectionItemMutation();
  const [ addRackCabinetCustomItem ] = useAddRackCabinetCustomItemMutation();
  const [ addCableCustomItem ] = useAddCableCustomItemMutation();
  const [ addConventionalDevicesCustomItem ] = useAddConventionalDevicesCustomItemMutation();

  const [showTools, setShowTools] = useState(false);

  const confirmCustomRow = useCallback(() => {
    if (customItem && entityType && entityId) {
      addEditableMinusRow(
          customItem,
          entityType,
          entityId,
          currency,
          originalQuantity,
          addRoomCustomItem,
          addProjectCustomItem,
          addElectricalCustomItem,
          addNhcCustomItem,
          addRackCabinetCustomItem,
          addCableCustomItem,
          addConventionalDevicesCustomItem,
          addCustomSectionItem,
      );
    }
    setCurrentRowInEditing({});
  }, [customItem, entityType, entityId, currency]);

  const handleChange = (event: any) => {
    const newCustomItem = Object.assign({}, customItem);
    setCustomItem({
      ...newCustomItem,
      [event.target.id]: -Math.abs(event.target.value),
    });
  };

  const originalQuantity = useMemo(() => {
    return customItem.quantity;
  }, []);

  useEffect(() => {
    setTimeout(function () {
      const elem = document.querySelector(".minus-row");
      if (elem) {
        elem.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }, 100);
  }, []);

  return !IS_READ_ONLY_USER ? (
      <Fragment>
        <tr className="group group-start">
          <td colSpan={neededCols.length}>{ts("quote_custom", "Custom")}</td>
        </tr>
        <tr
            role="row"
            // className={`product-row ${row.rowIdx % 2 ? "even" : "odd"}`}
            className={`product-row minus-row`}
            onMouseEnter={() => setShowTools(true)}
            onMouseLeave={() => setShowTools(false)}
        >
          {neededCols.map((col: any, key: any) => (
              <TableCell
                  key={key}
                  width={col.data === "manufacturer_name" || col.data === "custom_description" ? "200" : "width" in col ? col.width : "auto"}
                  numeric={col.numeric}
                  cellCallback={col.cellCallback}
              >
                {col.data === "quantity" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ marginRight: "5px" }}>-</span>
                      <CustomCell
                          isNumeric={true}
                          cellName={col.data}
                          defaultValue={Math.abs(customItem.quantity)}
                          handleChange={handleChange}
                          autoFocus={true}
                          confirmRow={confirmCustomRow}
                          cancelRow={cancelCustomRow}
                          customItem={customItem}
                      />
                    </div>
                ) : (
                    <div style={{ display: "flex", alignItems: "center", height: "40px", padding: "0 15px", textAlign: "left" }}>
                      {col.render(customItem[col.data], customItem, {
                        measurementSystem: measurementSystem,
                      })}
                    </div>
                )}

                {showTools && col.data === "product_name" ? (
                    <RowTools
                        cancelCustomRow={cancelCustomRow}
                        confirmCustomRow={confirmCustomRow}
                        modifyRow={customMinusRowButtonPressed}
                        setModifyRow={setCustomMinusRowButtonPressed}
                        minusRow={true}
                    />
                ) : null}
              </TableCell>
          ))}
        </tr>
      </Fragment>
  ) : null;
};
